/**
 * @desc 修改部门
 */
import { DeptEntity, DeptForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateDeptParameter = DeptForm

const method = 'PUT'
const url = '/auth/dept'

export const updateDeptApi = (
  data?: UpdateDeptParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<DeptEntity>({
    method,
    url,
    data,
    ...config
  })
}

updateDeptApi.method = method
updateDeptApi.url = url
